import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./index.module.scss";
import { memo } from "react";

interface AttendanceColProps {
    sessionId: string;
    isSessionOpen: boolean;
    entityLanguage: string;
    sessionUpdate: boolean;
    isUserRegistered:  boolean;
    isFeed?: boolean;
    sessionDescription?: string;
    related?: Array<any>;
    folderBySessionLength?: number;
    zoomUrl?: string;
    registerToClass: (id: string) => void;
    unregisterToClass: (id: string) => void;
    isToggle: boolean;
    toggleEvent: () => void;
}

const AttendanceCol = ({
    sessionId,
    isSessionOpen,
    entityLanguage,
    sessionUpdate,
    isUserRegistered,
    isFeed,
    sessionDescription,
    related,
    folderBySessionLength,
    isToggle,
    zoomUrl,
    registerToClass,
    unregisterToClass,
    toggleEvent
}: AttendanceColProps) => {
    const [t] = useTranslation(entityLanguage);
    const isButtonDisabled = sessionUpdate;
    const btnText = !isUserRegistered ? t("Attend") : t("Cancel");

    const handleAttendance = () => {
        if (!isUserRegistered) {
            registerToClass(sessionId);
        } else {
            unregisterToClass(sessionId);
        }
    }

    return (
        <div className={`${styles.attendance} ${entityLanguage !== "English" ? styles.isNotEnglish : ""}`}>
            {isToggle && (
                <button className={`${styles.attendButton} ${isButtonDisabled ? styles.disabled : ""} ${isUserRegistered ? styles.attended : ""}`}
                    disabled={isButtonDisabled}
                    onClick={() => handleAttendance()}>
                    {btnText}
                </button>
            )}

            {!isFeed &&
                (sessionDescription ||
                    (related && related.length > 0) ||
                    (folderBySessionLength > 0) || zoomUrl) && (
                    <div className={`${styles.moreInfo} ${isSessionOpen ? styles.open : ""}`} onClick={toggleEvent}>
                        <span className={styles.arrow}>{t("moreInfo")}</span>
                        <ExpandMoreIcon />
                    </div>
                )}
        </div>
    )
};

export default memo(AttendanceCol);